//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sidebar from '../../../../components/sidebar';
import Dialog from '../dialog';
import DialogCard from '../dialogCard';

export default ({
  // дополнительные свойства и методы
  components: {
    Dialog,
    DialogCard,
  },
  extends: Sidebar,
});
